import React from 'react';
import { Table } from 'reactstrap';
import SortableTh from '@src/components/SortableTh/SortableTh';
import moment from 'moment';
import { Link } from 'react-router-dom';
export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <thead>
        <tr>
          <SortableTh {...props} label={'Phase'} field={'phase_no'} />
          <SortableTh {...props} label={'Address #'} field={'address_no'} />
          <SortableTh {...props} label={'Street'} field={'Street'} />
          <SortableTh {...props} label={'Unit #'} field={'unit_no'} />
          <th>EOIs</th>
        </tr>
      </thead>
      <tbody>
        {props.entities.map(item => {
          return (
            <tr className="pointer" key={'unit-table-' + item.id}>
              <td onClick={e => props.onEntityClick(item.id)}>
                {item.phase_no}
              </td>
              <td onClick={e => props.onEntityClick(item.id)}>
                {item.address_no}
              </td>
              <td onClick={e => props.onEntityClick(item.id)}>{item.street}</td>
              <td onClick={e => props.onEntityClick(item.id)}>
                {item.unit_no}
              </td>
              <td>
                {item.evidence_of_insurances.length === 0 ? (
                  '---'
                ) : (
                  <React.Fragment>
                    {item.evidence_of_insurances.map((item, index) => {
                      const issueDate = moment(item.issue_date * 1000).format(
                        'MM/DD/YYYY'
                      );
                      if (index > 0) {
                        return false;
                      }
                      return (
                        <Link
                          key={'eois-link-' + item.id}
                          to={`/eois/${item.id}`}
                          className={'mr-1 link'}
                        >
                          {issueDate}
                        </Link>
                      );
                    })}
                  </React.Fragment>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
